module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eeLGK"))).then(() => parcelRequire('d0iPb'));